import { SaveDiscountResultError } from "app/shared/model/SaveDiscountResultDto";

export enum EditorStatus {
    NoRecord,
    Loaded
}

export type NoState = {
    status: EditorStatus.NoRecord
}

export type LoadedState = {
    status: EditorStatus.Loaded
    id: string|undefined
    saveError: SaveErrorValue
    changeNumber: number
    savedNumber: number
    savingNumber: number|undefined
    errors: ErrorMap
    showSuccessMessage: boolean
}

export type ErrorMap = {
    [category: string]: string[]
}

export enum SaveErrorValue {
    NoError,
    Invalid,
    Error
}

export enum DiscountSaveStatus {
    NoChanges,
    ChangesToSave,
    SavingChanges
}

export type EditorState = 
    NoState
    | LoadedState